<template>
  <div ref="box" :class="{ box: mask && !paused }">
    <MarqueeText :duration="duration" :repeat="paused ? 1 : 2" :paused="paused">
      <div class="text">{{ text }}</div>
    </MarqueeText>
  </div>
</template>
<script>
import MarqueeText from "vue-marquee-text-component";
export default {
  name: "OverMarqueeText",
  components: {
    MarqueeText,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      default: 10,
    },
    mask: {
      type: Boolean,
      default: true,
    },
    delay: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      paused: true,
    };
  },

  mounted() {
    const width = this.getTextWidth(this.text);
    const boxEle = this.$refs.box;
    setTimeout(() => {
      this.paused = width < boxEle.clientWidth;
      console.log(this.paused);
    }, this.delay);
    // console.log(boxEle.clientWidth, width);
  },

  methods: {
    getTextWidth(text) {
      const span = document.createElement("span");
      span.textContent = text;
      document.body.appendChild(span);
      const width = span.offsetWidth;
      document.body.removeChild(span);
      return width;
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  -webkit-mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgb(0, 0, 0) 12.5%,
    rgb(0, 0, 0) 87.5%,
    rgba(0, 0, 0, 0) 100%
  );
}
.text {
  padding-right: 20px;
}
</style>
